import styled, { css } from 'styled-components'
import Input from './Input'
import { truncateStyles } from 'components/Truncate'

const InputContainer = styled.div`
  display: flex;
  flex: 1;
`

const InputBackground = styled(Input)`
  display: block;
  width: 100%;
`

const InputValueContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 40px;
  margin-left: -100%;
  padding: 12px;
  z-index: 1;
`

const InputValue = styled.span(
  ({ theme }) => css`
    ${truncateStyles}

    color: ${theme.colors.foreground.secondary[4]};
    font-size: ${theme.fontSizes.small};
  `
)

const DecoratedInputStyles = {
  Container: InputContainer,
  Background: InputBackground,
  Value: Object.assign(InputValue, {
    Container: InputValueContainer,
  }),
}

export default DecoratedInputStyles
